import React, { useState } from "react"
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
//import { ChartsItemTooltipContent } from '@mui/x-charts/ChartsTooltip';
import { useDrawingArea } from '@mui/x-charts/hooks';
import {blueberryTwilightPalette, mangoFusionPalette, cheerfulFiestaPalette, } from '@mui/x-charts/colorPalettes';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));


const data = [
    {id: 0, value: 55.39, label: "Bacteroidetes"},
    {id: 1, value: 36.24, label: "Firmicutes"},
    {id: 2, value: 5.99, label: "Proteobacteria"},
    {id: 3, value: 1.76, label: "Actinobacteria"},
    {id: 4, value: 0.62, label: "Verrucomicrobia"}
] 

const palettes = {
    blueberryTwilight: blueberryTwilightPalette,
    mangoFusion: mangoFusionPalette,
    cheerfulFiesta: cheerfulFiestaPalette,
  };

const size = {
    width: 400,
    height: 240,
  };
  
const StyledText = styled('text')(({ theme }) => ({
fill: theme.palette.text.light,
textAnchor: 'middle',
dominantBaseline: 'central',
fontSize: '0.7rem',


}));


function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
        <StyledText x={left + width / 2} y={top + height / 2}>
        {children}
        </StyledText>
    );
    }

export default function Mikrochartdiversity() {

const [colorScheme, setColorScheme] = useState('cheerfulFiesta');

    return (
<>
     
        <PieChart margin={{ top: 0, bottom: 0, left:20, right: 150 }}
                  colors={palettes[colorScheme]}
                  series={[{  data, 
                              innerRadius: 72, outerRadius: 100, cornerRadius: 5, paddingAngle: 3, cx:110,
                              highlightScope: { faded: 'global', highlighted: 'item' }, faded: { innerRadius: 30, additionalRadius: -30, color: 'white', },
                                }]} 
                  tooltip={{  trigger: 'item', '& .base-Popper-root': { bgcolor: 'common.white'}, '& .MuiChartsTooltip-root': { bgcolor: 'common.white'},
                  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: 'common.white', color: 'common.white', },}}
                  slotProps={{ 
                              legend: { direction: 'column', position: { vertical: 'middle', horizontal: 'right' }, 
                              itemMarkWidth: 10, itemMarkHeight: 10, markGap: 10, itemGap: 10, 
                              labelStyle: { fontSize: '0.7rem', fill: 'white',  },
                              margin: {  },
                              
                              },
                  }}
                  sx={{ [`& .${pieArcLabelClasses.root}`]: { fill: 'white', fontWeight: 'bold', }, }}
                            
                  {...size}
                 
                  >
        
        <PieCenterLabel>COMPOSITION</PieCenterLabel>
        
     

        </PieChart>

 </>
    );
}

/*
colors={['red', 'blue', 'green']} // Use palette

Sizing:

innerRadius: 30,
      outerRadius: 100,
      paddingAngle: 5,
      cornerRadius: 5,
      startAngle: -90,
      endAngle: 180,
      cx: 150,
      cy: 150,

Labels:

series={[
    {
      arcLabel: (item) => `${item.label} (${item.value})`,
      arcLabelMinAngle: 45,
      data,
    },
  ]}
  sx={{
    [`& .${pieArcLabelClasses.root}`]: {
      fill: 'white',
      fontWeight: 'bold',
    },
  }}
  {...size}

Legend:

 margin={{ top: 100, bottom: 100, left: 100, right:100 }}
  {/** ... * /}
  slotProps={{
    legend: {
      
    direction: 'column',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: 69,
      
      itemMarkWidth: 20,
      itemMarkHeight: 2,
      markGap: 5,
      itemGap: 10,

      labelStyle: {
        fontSize: 14,
        fill: 'blue',
      
    },
    margin: { top: 20, right: 100,  },
    },
  }}


*/